<template>
  <div class="input-errors" v-for="error of errorList" :key="error.$uid">
    <ErrorLabel :error="error.$message"></ErrorLabel>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import { ErrorObject } from "@vuelidate/core";
import ErrorLabel from "@/modules/ui/ErrorLabel.vue";

@Options({
  components: { ErrorLabel },
  props: {
    errors: Array,
    single: Boolean,
    singleValidator: String,
  },
})
export default class ValidationErrors extends Vue {
  single!: boolean;
  errors!: ErrorObject[];
  singleValidator!: string;

  get errorList(): ErrorObject[] {
    if (!this.errors.length) {
      return [];
    }

    if (this.singleValidator) {
      return this.errors.filter(
        (err) => err.$validator === this.singleValidator
      );
    }

    return this.single ? [this.errors[0]] : this.errors;
  }
}
</script>

<style lang="scss" scoped>
.input-errors {
  display: block;
  margin-top: 5px;
}
</style>
